export default "__VITE_ASSET__C50Z9MGp__"